export default __webpack_public_path__ + "static/media/lifeCycle.3e19523d.png";